import type { CSSProperties } from "react";

export const pageContent: CSSProperties = {
  padding: "0 var(--page-pad-x) var(--page-pad-b)",
};

export const table: CSSProperties = {
  width: "100%",
  borderCollapse: "collapse",
  fontSize: 13,
};
export const th: CSSProperties = {
  textAlign: "left",
  padding: "5px 12px",
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: "0.08em",
  textTransform: "lowercase",
  color: "var(--fg-3)",
  borderBottom: "1px solid var(--comp-rule)",
};
export const thFirst: CSSProperties = { ...th, paddingLeft: 0 };
export const td: CSSProperties = { padding: "var(--row-pad)" };
export const tdFirst: CSSProperties = { ...td, paddingLeft: 0 };
export const row: CSSProperties = {
  borderBottom: "1px solid var(--comp-rule)",
};
export const metaText: CSSProperties = {
  fontFamily: "var(--font-mono)",
  fontSize: 11,
  color: "var(--fg-3)",
};

/** Secondary-ink body cell. */
export const tdMuted: CSSProperties = { ...td, color: "var(--fg-2)" };
/** Monospace cell for ids, actors and timestamps. */
export const tdMono: CSSProperties = { ...td, ...metaText };
/** Inline error line above a table. */
export const errorText: CSSProperties = {
  color: "var(--comp-salmon)",
  fontSize: 13,
  marginBottom: 12,
};
